module.exports = __webpack_public_path__ + "media/images/contact-banner-2cac93c2500e96533eba76a5085a60b7.jpg";